import React from "react";
import "./documentViewer.css";

import Download from "./download.png";

function DocumentViewer({ documents }) {
    if (!documents || documents.length === 0) return <p>Nema dokumenata koja odgovaraju unetim parametrima.</p>;
    const handleDownload = (pdfUrl, fileName) => {
        const link = document.createElement("a");
        link.href = pdfUrl;
        link.setAttribute("download", fileName + ".pdf");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div className="document-viewer">
            <table className="document-table">
                <thead>
                    <tr>
                        <th>NAZIV DOKUMENTA</th>
                        <th>GODINA</th>
                        <th>VERZIJA</th>
                        <th>PDF</th>
                        <th>WORD</th>
                    </tr>
                </thead>
                <tbody style={{ width: "100%" }}>
                    {documents.map((doc, index) => (
                        <tr key={doc.id}>
                            {doc.active ? (<>
                                <td style={{ color: "green" }}>
                                    {doc.title}
                                </td>
                            </>) : (<>
                                <td style={{ color: "red" }}>
                                    {doc.title}
                                </td>
                            </>)}
                            <td>
                                {doc.year}.
                            </td>
                            <td>
                                {doc.version}. Verzija
                            </td>
                            <td>
                                <a href={doc.pdf_url} download rel="noreferrer" target="_blank">
                                    <img src={Download} alt="Preuzmi" />
                                </a>
                            </td>
                            <td>

                                <a href={doc.word_url} download target="_blank">
                                    <img src={Download} alt="Preuzmi" />
                                </a>

                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}


export default DocumentViewer;
